import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'

const OrderStatusContext = createContext(null)

export function OrderStatusProvider({ children }) {
  const [isOpen, setOpen] = useState(false)
  const [orderStatusColumn, setOrderStatusColumn] = useState('left')

  const openOrderStatus = useCallback(({ column = 'left' } = {}) => {
    setOrderStatusColumn(column === 'right' ? 'right' : 'left')
    setOpen(true)
  }, [])
  const closeOrderStatus = useCallback(() => {
    setOpen(false)
    setOrderStatusColumn('left')
  }, [])

  const value = useMemo(
    () => ({
      isOrderStatusOpen: isOpen,
      orderStatusColumn,
      openOrderStatus,
      closeOrderStatus,
    }),
    [isOpen, orderStatusColumn, openOrderStatus, closeOrderStatus],
  )

  return (
    <OrderStatusContext.Provider value={value}>
      {children}
    </OrderStatusContext.Provider>
  )
}

export function useOrderStatus() {
  const ctx = useContext(OrderStatusContext)
  return (
    ctx || {
      isOrderStatusOpen: false,
      orderStatusColumn: 'left',
      openOrderStatus: () => {},
      closeOrderStatus: () => {},
    }
  )
}
